import http from '@/utils/http'
import { transformDate } from '@/utils/date'
import { getField, updateField } from 'vuex-map-fields'

const REFRESH_INTERVAL = 10000
let refreshIntervalId = null

const initialState = () => ({
  list: [],
  filter: {
    subscriptionId: null,
    isActive: '',
    term: '',
    type: null,
    showUnusedJobs: false
  },
  useGroups: null
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })

    if (refreshIntervalId) {
      clearInterval(refreshIntervalId)
    }
  },
  SET_LIST (state, list = []) {
    state.list = list
  },
  updateField
}

export const getters = {
  list: state => state.list,
  filteredList: state => {
    let list = state.list

    if (state.filter.term) {
      const term = state.filter.term.toLowerCase()
      list = list.filter(item => item.JobName.toLowerCase().includes(term) || item.ID.toString().includes(term))
    }

    if (typeof state.filter.isActive === 'number') {
      // using + to solve cases where item.IsActive is null
      list = list.filter(item => +item.IsActive === state.filter.isActive)
    }

    if (state.filter.type) {
      list = list.filter(item => item.JobType === state.filter.type)
    }

    if (!state.filter.showUnusedJobs) {
      list = list.filter(item => item.JobType !== 'Not in use')
    }

    return list.map(item => {
      item._lastRunTime = transformDate(item.LastRunTime)
      item.hasError = !!item.FileErrorCount || !!item.FileFailedCount || !!item.ErrorCount || !!item.FailedCount || !!item.ErrorMessage

      return item
    })
  },
  totalJobs: state => state.list.length,
  getField
}

export const actions = {
  fetchJobList ({ commit, state, rootGetters }) {
    let request = null
    if (state.filter.subscriptionId) {
      request = http({
        url: `${process.env.VUE_APP_API_URL}jobs/statusbysubscription/${rootGetters['auth/token']}/${state.filter.subscriptionId}`
      })
    } else {
      request = http({
        url: `${process.env.VUE_APP_API_URL}jobs/statusbycustomer/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}`
      })
    }

    return request.then(data => {
      commit('SET_LIST', data)
      return data
    })
  },
  // using this action to keep session alive and always having up-to-date list of jobs
  setTimer ({ dispatch, state }, force = false) {
    if (!refreshIntervalId || force) {
      if (refreshIntervalId) {
        clearInterval(refreshIntervalId)
      }

      // loading jobs immediately
      dispatch('fetchJobList')

      refreshIntervalId = setInterval(() => {
        dispatch('fetchJobList')
          .catch(e => {
            // killing auto refresh if anything goes wrong to prevent unnecessary failing requests
            clearInterval(refreshIntervalId)
          })
      }, REFRESH_INTERVAL)
    }
  },
  stopTimer () {
    if (refreshIntervalId) {
      clearInterval(refreshIntervalId)
    }
  }
}
